import moment from "moment-timezone";

/**
 * Recursively crawls values of a JSON object and casts strings that represent datetimes into Date objects
 * @TODO: Move this into the API client ASAP. Should go into the camel-casing code.
 * @param {Object} json - may or may not have some values with string-encoded dates
 * @returns {Object}
 */
export default function castDates(json) {
  for (let key in json) {
    const value = json[key];

    // TODO: REMOVE THIS.
    // Don't try to cast headlines because this breaks the dashboard.
    if (key === "headline") {
      continue;
    }

    if (typeof value === "string" && moment(value, moment.ISO_8601).isValid()) {
      json[key] = moment(value, moment.ISO_8601);
    } else if (typeof value === "object") {
      json[key] = castDates(value);
    }
  }

  return json;
}
